import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Austin Andrews
 * id 74ACC301-AA62-492B-92C1-8021BDD89A02
 * name chevron-double-down
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/chevron-double-down.svg
 * tags
 * - Arrow 
 */
export const ChevronDoubleDownIcon = createSvgIcon(<><path d="M16.59,5.59L18,7L12,13L6,7L7.41,5.59L12,10.17L16.59,5.59M16.59,11.59L18,13L12,19L6,13L7.41,11.59L12,16.17L16.59,11.59Z" /></>, 'ChevronDoubleDownIcon');
export default ChevronDoubleDownIcon